import Header from "../../components/dashboard/header";
import {Breadcrumb, Button, Form, Input, message, Modal, Popconfirm, Select, Space, Spin} from "antd";
import {DashboardOutlined, PlusSquareOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {AiOutlineSetting} from "react-icons/ai";
import {TbFileSettings} from "react-icons/tb";
import UploadButton from "../../components/common/uploadButton";
import DataTable from "../../components/common/table";
import {useContext, useRef, useState} from "react";
import {INFLOW, OUTFLOW} from "../../shared/flowType";
import RefreshContext from "../../context/refreshContext";
import {
    useCreateStaffCategory, useDeleteStaffCategory,
    useFetchAllStaffCategories,
    useUpdateStaffCategory
} from "../../hooks/staffcategory/staffCategoryQuery";
import {extractValueFromInputRef} from "../../helpers/dom";

const { Option } = Select


const categoryColumns = [
    {
        title:'S/N',
        dataIndex:'id',
        key:'id',
        render:(_,__,idx)=>idx+1
    },
    {
        title:"Title",
        dataIndex:"title",
        key:"title"
    },
    {
        title:'Value',
        dataIndex:'value',
        key:'value'
    },
    {
        title:'Action',
        key:'action',
        render:(_,item)=>(
            <EditStaffCategory category={item}/>
        )
    }
]

function EditStaffCategory({category}){
    const titleRef = useRef(null)
    const valueRef = useRef(null)
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const {flag, setFlag} = useContext(RefreshContext)

    const showCreateModal = () => setIsOpen(true)
    const hideCreateModal = () => setIsOpen(false)

    const updateStaffCategory = useUpdateStaffCategory()
    const deleteCategory = useDeleteStaffCategory()

    const handleSubmit = async () => {
        setLoading(true)
        const d = await updateStaffCategory(category.id, {
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef)
        })
        message.success("Category updated successfully")
        setLoading(false)
        setFlag(!flag)
        // hideCreateModal()
    }

    const handleDelete = async (i) => {
        setLoading(true)
        const d = await deleteCategory(i.id)
        message.success("Category deleted")
        setLoading(false)
        setFlag(!flag)
    }

    return (
        <>
            <Space>
                <Button type="primary" onClick={showCreateModal}>Edit</Button>
                <Popconfirm
                    title="Delete this staff category"
                    description="Are you sure to delete this ?"
                    onConfirm={() => handleDelete(category)}
                    onCancel={() => null}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="primary" style={{backgroundColor: 'red'}}>Delete</Button>
                </Popconfirm>

            </Space>
            <Modal footer={null} open={isOpen} onCancel={hideCreateModal} title="Edit budget category">
                <Form initialValues={{
                    ...category
                }}>
                    <Form.Item name='title'>
                        <Input type="text" ref={titleRef} placeholder="Enter title"/>
                    </Form.Item>
                    <Form.Item name="value">
                        <Input type="text" ref={valueRef} placeholder="Enter value"/>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            span:8,
                            offset:20
                        }}
                        className="submit-button-wrapper"
                    >
                        <Button loading={loading} style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default function StaffCategory(){

    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const titleRef = useRef(null)
    const valueRef = useRef(null)
    const {flag, setFlag} = useContext(RefreshContext)

    const showCreateModal = () => setIsOpen(true)
    const hideCreateModal = () => setIsOpen(false)

    const createCategory = useCreateStaffCategory()

    const {categories} = useFetchAllStaffCategories(flag)

    const handleSubmit = () => {
        setLoading(true)
        const d = createCategory({
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef)
        })
        setFlag(!flag)
        setLoading(false)
        // hideCreateModal()
    }

    return(
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <AiOutlineSetting/>
                                <Link to={"/dashboard"}>Configuration</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <TbFileSettings />
                                <Link to="/dashboard/budget-category">Staff Category</Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div style={{display:'flex',gap:'1em'}}>
                            <UploadButton/>
                            <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={showCreateModal}>
                                <PlusSquareOutlined />
                                Add New Category
                            </Button>
                        </div>
                    </div>

                    <div className="table-section">
                        <Spin spinning={loading}>
                            <DataTable cols={categoryColumns} data={categories}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal open={isOpen} title={'Add Categories'} footer={null} onCancel={hideCreateModal}>
                <Form>
                    <Form.Item name='title'>
                        <Input type="text" ref={titleRef} placeholder="Enter title"/>
                    </Form.Item>
                    <Form.Item name="value">
                        <Input type="text" ref={valueRef} placeholder="Enter value"/>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            span:8,
                            offset:20
                        }}
                        className="submit-button-wrapper"
                    >
                        <Button loading={loading} style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                            Create
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
